// extracted by mini-css-extract-plugin
export default {"wrapper":"WishlistPage_wrapper__IN3cW"};